module.exports = __webpack_public_path__ + "images/marketing_site/img22.png";